<div class="ai-chat-trigger" (click)="openChat()">
    <div class="ai-chat-trigger__main">
        <div class="ai-chat-trigger__icon-container">
            <img src="assets/icons/help.svg" alt="Help" class="ai-chat-trigger__icon">
        </div>
    </div>
    <div class="ai-chat-trigger__glow"></div>
    <div class="ai-chat-trigger__border"></div>
</div>